export default __webpack_public_path__ + "static/real-time-data-updates-3ceb98fd03e0c3c285cfbabb5b0edc8e.png";